export default __webpack_public_path__ + "static/beauty-look-summer-47b5a94152915454574cfa0198839481.jpg";